<div class="w-full flex justify-center sticky top-0">
    <h1 class="font-mono font-bold text-5xl">{{playlist()?.title}}</h1>
</div>

@if(videos().length === 0){
    <div class="w-full flex justify-center p-10">
        <h2 class="font-mono font-bold text-2xl">No videos found</h2>
    </div>
}@else{
    <div class="w-full p-10 grid gap-4 grid-cols-[repeat(auto-fit,minmax(250px,1fr))]">
        @for(video of videos(); track $index) {
            <app-video [video]="video"></app-video>
        }
    </div>
}

